import { get, del, post, put } from "../../helpers/utils/http-client";
import {APPS_ENDPOINT} from '../../consts/api-endpoints';

export async function listDataSources(appId) {
    return await get(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources`);
}

export async function viewDataSource(appId, dataSourceId, output = '') {
    try {
        const params = output ? { output } : {};
        const { response, status } = await get(
            `${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}/preview`,
            params
        );
        if (status !== 200) {
            throw new Error(response);
        }
        return { response, status };
    } catch (error) {
        return {
            status: error?.status,
        };
    }
}

export async function deleteDataSources(appId, dataSourceId, returnOriginal='') {
    return await del(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}?returnOriginal=${returnOriginal}`);
}

export async function approveDataSource(appId, dataSourceId) {
    return await post(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}/approve`, {});
}

export async function getDataSourceOcrAudit(appId, dataSourceId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}/ocr-audit`);
        if (status !== 200) {
            throw new Error(response);
        }
        return { response, status };
    } catch (error) {
        return {
            status: error?.status,
            error: error?.message,
        };
    }
}

export async function updateDataSourceContent(appId, dataSourceId, content, extra = {}) {
    return await put(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}/content`, { content, ...extra });
}

export async function searchKnowledge(appId, dataSourceId, query, topK = 100) {
    return await post(`${APPS_ENDPOINT}/${appId}/knowledge/search`, {
        appId,
        docId: dataSourceId,
        query,
        topK,
    });
}
